import { render, staticRenderFns } from "./ProjectFiles.vue?vue&type=template&id=b8b6953a&scoped=true"
import script from "./ProjectFiles.vue?vue&type=script&lang=js"
export * from "./ProjectFiles.vue?vue&type=script&lang=js"
import style0 from "./ProjectFiles.vue?vue&type=style&index=0&id=b8b6953a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6953a",
  null
  
)

export default component.exports